import { PageRoute } from "@compass/core";
import { DataModelEnum } from "generated/openApi";
import "moment-timezone";
import { collegeListPageRoute } from "../colleges/CollegeListPage/CollegeListPage";
import { districtListPageRoute } from "../districts/DistrictListPage/DistrictListPage";
import { endReasonListPageRoute } from "../endReasons/EndReasonListPage/EndReasonListPage";
import { schoolListPageRoute } from "../schools/SchoolListPage/SchoolListPage";
import { studentServiceTypeListPageRoute } from "../studentServiceTypes/StudentServiceTypeListPage/StudentServiceTypeListPage";
import { gradeListPageRoute } from "../grades/GradeListPage/GradeListPage";
import { providerListPageRoute } from "pages/providers/providers/ProviderListPage/ProviderListPage";
import { studentServiceIndexListPageRoute } from "pages/students/student-service-indexes/StudentServiceIndexListPage/StudentServiceIndexListPage";
import { deletedStudentsListPageRoute } from "../deletedStudents/DeletedStudentListPage/DeletedStudentListPage";
import { staffServiceTypeListPageRoute } from "../staffServiceTypes/StaffServiceTypeListPage/StaffServiceTypeListPage";
import { fileCategoryListPageRoute } from "../fileCategories/FileCategoryListPage/FileCategoryListPage";

type UtilityMenuItem = {
  dataModelEnum: DataModelEnum; // for fetching current order method
  handle: string;
  getPath: () => void;
  orderable?: boolean;
};

export const utilityMenuItems: UtilityMenuItem[] = [
  {
    dataModelEnum: DataModelEnum.StudentServiceIndex,
    handle: studentServiceIndexListPageRoute.handle,
    getPath: () => studentServiceIndexListPageRoute.getPath({ screenType: "standard" }),
  },
  {
    dataModelEnum: DataModelEnum.Grade,
    handle: gradeListPageRoute.handle,
    getPath: () => gradeListPageRoute.getPath(),
    orderable: true,
  },
  {
    dataModelEnum: DataModelEnum.Provider,
    handle: providerListPageRoute.handle,
    getPath: () => providerListPageRoute.getPath(),
  },
  {
    dataModelEnum: DataModelEnum.School,
    handle: schoolListPageRoute.handle,
    getPath: () => schoolListPageRoute.getPath(),
  },
  {
    dataModelEnum: DataModelEnum.District,
    handle: districtListPageRoute.handle,
    getPath: () => districtListPageRoute.getPath(),
  },
  {
    dataModelEnum: DataModelEnum.StudentServiceType,
    handle: studentServiceTypeListPageRoute.handle,
    getPath: () => studentServiceTypeListPageRoute.getPath(),
  },
  {
    dataModelEnum: DataModelEnum.College,
    handle: collegeListPageRoute.handle,
    getPath: () => collegeListPageRoute.getPath(),
  },
  {
    dataModelEnum: DataModelEnum.Student,
    handle: deletedStudentsListPageRoute.handle,
    getPath: () => deletedStudentsListPageRoute.getPath(),
  },
  {
    dataModelEnum: DataModelEnum.EndReason,
    handle: endReasonListPageRoute.handle,
    getPath: () => endReasonListPageRoute.getPath(),
    orderable: true,
  },
  {
    dataModelEnum: DataModelEnum.StaffServiceType,
    handle: staffServiceTypeListPageRoute.handle,
    getPath: () => staffServiceTypeListPageRoute.getPath(),
  },
  {
    dataModelEnum: DataModelEnum.FileCategory,
    handle: fileCategoryListPageRoute.handle,
    getPath: () => fileCategoryListPageRoute.getPath(),
  },
];
